module.exports = __webpack_public_path__ + "img/25_58.38b70757.png";